import { render, staticRenderFns } from "./CustomCollapsable.vue?vue&type=template&id=1751a3a0&scoped=true&"
import script from "./CustomCollapsable.vue?vue&type=script&lang=js&"
export * from "./CustomCollapsable.vue?vue&type=script&lang=js&"
import style0 from "./CustomCollapsable.vue?vue&type=style&index=0&id=1751a3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1751a3a0",
  null
  
)

export default component.exports